// extracted by mini-css-extract-plugin
export default {"button":"_1DIEO","title":"IIsv8","addToWalletTitle":"Fr2f-","spinnerContainer":"BfNpM"};